"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const common_1 = require("../../../../common");
const react_redux_1 = require("react-redux");
// @ts-ignore
const GlobalStateProvider_1 = require("../../../../GlobalStateProvider");
const function_1 = require("../../../menu/function");
const action_1 = require("../../../menu/action");
const classes_1 = require("../../classes");
const DSLayoutHeader = react_1.default.memo(({ isTeacher, title, isHome, children, isScrolled = false, isHovered = false, setIsHovered, selectedMenu, setMenu, }) => {
    const { isDesktop, isTablet, isMobile } = (0, GlobalStateProvider_1.useGlobalState)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const hiddenMenus = (0, react_redux_1.useSelector)((state) => (0, classes_1.getHiddenMenus)(state));
    const option = {
        titleIcon: {
            show: isMobile || isTablet ? true : false,
            size: 24,
        },
    };
    const updateNewMenu = (depths, menu, id) => {
        dispatch((0, action_1.updateMenu)(depths, menu, id));
    };
    const renderMenuBar = (0, react_1.useCallback)((depths, list) => {
        return (react_1.default.createElement(common_1.MenuBar, { className: "lnb-menu", isRow: false, isClickDisabled: false, list: list, value: selectedMenu, onItemClick: (changeMenu) => {
                const isDepthClick = changeMenu === depths;
                const nextMenu = isDepthClick
                    ? (0, function_1.getDefaultMenuByDepth)(depths, isTeacher, hiddenMenus)
                    : changeMenu;
                updateNewMenu(depths, // depths
                {
                    menu: nextMenu,
                    detail: 'list', // Matches IMenuDetailProps
                } // menu object
                );
                setIsHovered(false);
            }, setIsHovered: setIsHovered, option: option }));
    }, [selectedMenu, option]);
    const list = (0, react_1.useMemo)(() => {
        const filteredList = (0, function_1.getFilterMenuList)(isTeacher, hiddenMenus);
        return filteredList;
    }, [isTeacher, hiddenMenus]);
    const filteredMenuSections = (0, react_1.useMemo)(() => list.map(depths => ({
        depths,
        list: (0, function_1.getVisibleDepthMenus)(depths, isTeacher, hiddenMenus),
    })), [list, isTeacher, hiddenMenus]);
    return (react_1.default.createElement("div", { className: `navbar ${isHome ? (isScrolled || isHovered ? 'home scroll' : 'home') : ''}`, onMouseLeave: setIsHovered ? () => isDesktop && setIsHovered(false) : undefined },
        isHome && (react_1.default.createElement("div", { id: "element", className: isScrolled || isHovered ? 'overlay-on' : 'overlay-off' })),
        react_1.default.createElement("div", { className: "container", style: { flex: 2 } },
            (isDesktop || isHome) && (react_1.default.createElement(common_1.Button, { className: `btn-logo ${isHome && !isScrolled && !isHovered ? 'white' : undefined}`, option: {
                    buttonBeforeIcon: {
                        show: true,
                        width: 107,
                        height: 37,
                        name: isHome && !isScrolled && !isHovered ? 'logo_white' : 'logo',
                    },
                }, onClick: () => setMenu('home') })),
            children),
        isDesktop && (react_1.default.createElement("div", { className: `lnb ${isHovered ? 'active' : 'hide'}` }, filteredMenuSections.map(({ depths, list }) => (react_1.default.createElement("div", { className: "lnb-section", key: depths }, renderMenuBar(depths, list))))))));
});
exports.default = DSLayoutHeader;
